import { useCallback, useEffect, useRef, useState } from 'react';

const lesen = (k, init) => { try { const s = sessionStorage.getItem(k); return s !== null ? JSON.parse(s) : init; } catch { return init; } };

// Zustand, der beim Zurückgehen erhalten bleibt (pro Browser-Tab)
export const useMerkZustand = (key, init) => {
  const [st, setSt] = useState(() => ({ key, v: lesen(`merk:${key}`, init) }));
  const v = st.key === key ? st.v : lesen(`merk:${key}`, init);
  const setV = useCallback((n) => setSt((s) => {
    const alt = s.key === key ? s.v : lesen(`merk:${key}`, init);
    const neu = typeof n === 'function' ? n(alt) : n;
    try { sessionStorage.setItem(`merk:${key}`, JSON.stringify(neu)); } catch { /* voll */ }
    return { key, v: neu };
  }), [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return [v, setV];
};

export const merkLesen = (key, init = null) => lesen(`merk:${key}`, init);

// Scroll-Position eines eigenen Scroll-Containers merken
export const useScrollMerken = (key, bereit) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !bereit) return undefined;
    const s = Number(sessionStorage.getItem(`scroll:${key}`) || 0);
    if (s) requestAnimationFrame(() => { el.scrollTop = s; });
    const f = () => sessionStorage.setItem(`scroll:${key}`, String(el.scrollTop));
    el.addEventListener('scroll', f, { passive: true });
    return () => el.removeEventListener('scroll', f);
  }, [key, bereit]);
  return ref;
};
